//
// Tailwind Toggles
// --------------------------------------------------
// Updates a data-open attribute on target classes when a target element is clicked
// this attribute can be targeted with tailwind styles to display as required
// Toggle once option available for things only wanting to fire once

window.addEventListener('load', () => {
    const containersWithToggles = document.querySelector('[data-tw-toggle-container], [data-tw-toggle], #searchPanel');

    if (containersWithToggles) {
        document.addEventListener('click', (event) => {
            const target = event.target;

            // handles click
            function handleToggleClick(element) {
                if (element && element.matches('[data-tw-toggle-container][data-open], [data-tw-toggle-container][data-open-once]')) {
                    // sets state of data container based on data-open or data-open-once
                    if (element.hasAttribute('data-open')) {
                        element.dataset.open = element.dataset.open === 'false' ? 'true' : 'false';
                    }

                    if (element.hasAttribute('data-open-once') && element.dataset.openOnce === 'false') {
                        element.dataset.openOnce = 'true';
                    }
                }
            }

            // Walk up from the click target to find a [data-tw-toggle] ancestor.
            // The previous shallow check (target / parentElement) missed clicks that landed on
            // nested children — e.g. the FAQ <button> has a <p> two levels deep, and clicking
            // the question text never matched, so the toggle felt unresponsive.
            const toggle = target.closest?.('[data-tw-toggle]');
            if (toggle) {
                const toggleContainer = toggle.closest('[data-tw-toggle-container]');
                if (toggleContainer) {
                    handleToggleClick(toggleContainer);
                }
            }
        });
    }
});